import { Box, Button, useTheme } from "@mui/material";
import { sensorChartButtonStyle } from "../../styles/commonStyles";
import { CalendarMonth } from "@mui/icons-material";
import { useCallback, useEffect, useState } from "react";
import { addMonths, endOfToday, isAfter, isBefore } from "date-fns";
import ChartDatePicker from "../datePicker/chartDatePicker.component";

const TimeRangeButtons = ({
  selectedButton,
  handleButtonClick,
  onDateRangeChange,
}) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedDates, setSelectedDates] = useState([]);
  const open = Boolean(anchorEl);
  const today = endOfToday();

  const disabledDays = (day) => {
    if (isAfter(day, today)) {
      return true;
    }

    if (selectedDates.length === 1) {
      const firstSelectedDate = selectedDates[0];
      const maxDate = addMonths(firstSelectedDate, 6);
      return isBefore(day, firstSelectedDate) || isAfter(day, maxDate);
    }
    return false;
  };

  const handleOpen = (event) => {
    handleButtonClick("custom");
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDateSelect = (range) => {
    const dates = range?.from ? [range.from, range.to].filter(Boolean) : [];

    setSelectedDates(dates);
    onDateRangeChange(dates);
  };

  const handleReset = useCallback(() => {
    setSelectedDates([]);
    onDateRangeChange([]);
  }, [onDateRangeChange]);

  useEffect(() => {
    if (selectedButton !== "custom") {
      handleReset();
    }
  }, [handleReset, selectedButton]);

  return (
    <Box display="flex" gap={1}>
      <Button
        variant={selectedButton === "24h" ? "contained" : "outlined"}
        sx={sensorChartButtonStyle}
        onClick={() => handleButtonClick("24h")}
      >
        24h
      </Button>
      <Button
        variant={selectedButton === "7d" ? "contained" : "outlined"}
        sx={sensorChartButtonStyle}
        onClick={() => handleButtonClick("7d")}
      >
        7gg
      </Button>
      <Button
        startIcon={<CalendarMonth />}
        sx={{
          minWidth: "36px",
          width: "36px",
          height: "36px",
          justifyContent: "center",
          "& .MuiButton-startIcon": { margin: 0 },
        }}
        variant={selectedButton === "custom" ? "contained" : "outlined"}
        onClick={handleOpen}
      />
      {selectedButton === "custom" && (
        <ChartDatePicker
          open={open}
          anchorEl={anchorEl}
          handleClose={handleClose}
          selectedDates={selectedDates}
          handleDateSelect={handleDateSelect}
          disabledDays={disabledDays}
          theme={theme}
          handleReset={handleReset}
        />
      )}
    </Box>
  );
};

export default TimeRangeButtons;
